import type { AllRouteEndpoints } from "../routeTypes";

export const customObjectsUserCustomObjectTypeRelationships =
  "/custom_objects/user_custom_object_type_relationships";

export const customObjectsUserCustomObjectTypeRelationshipsCacheKeys: AllRouteEndpoints[] = [
  "/custom_objects/user_custom_object_type_relationships",
];
